import {FC, Fragment} from 'react'
import {Row} from 'react-table'
import { DLMSiteApplication } from '../../../../_models';
import clsx from 'clsx';
import { isPopulatedArray } from '../../../../../../../components/helpers';
import { PropsWithNotes, TableNotesRow } from '../../../../../../../components/table';

type Props = {
  row: Row<PropsWithNotes<DLMSiteApplication>>
}

const DLMLabellingCustomRow: FC<Props> = ({row}) => {

  const { key: rowKey, ...restRowProps } = row.getRowProps();

  const { showNotes, notes, requestTerminateNotes : terminationNotes } =  row.original;

  const has_notes = (row.original && showNotes && (isPopulatedArray(notes) || isPopulatedArray(terminationNotes)));
      
  return (
  <Fragment key={`Frag${rowKey}`}>
    <tr key={rowKey} {...restRowProps}>
      {row.cells.map((cell,cidx) => {
      const { key: cellKey, ...restCellProps } = cell.getCellProps();
      return (
        <td
          key={cellKey} 
          {...restCellProps}          
          rowSpan={(cidx < 2 && has_notes) ? 2 : 1}
          className={clsx('fs-7',                    
            {'align-top min-w-125px pt-4' : cidx < 2},              
          )}                
        >
          {cell.render('Cell')}
        </td>
      )
      })}
    </tr>
    { has_notes && 
    <TableNotesRow colSpan={6} notes={row.original.notes} />    
  }
  </Fragment>
  )
}

export {DLMLabellingCustomRow}
